import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useEffect } from 'react';
export var APP_NAME = 'CTA Portal';
export default function Page(_a) {
    var children = _a.children, pageKey = _a.pageKey;
    var _b = useI18n(), t = _b.t, i18n = _b.i18n;
    useEffect(function () {
        window.document.title = pageKey ? "".concat(t("".concat(pageKey, ".page-title")), " - ").concat(APP_NAME) : APP_NAME;
    }, [pageKey, t, i18n.language]);
    return children;
}
